import { LAYOUTS } from '../constants';
import getMeta from '@/utils/getMeta';

export default function({ router, store }) {

	function getLayout(to) {
		let layout = getMeta(to, 'layout', LAYOUTS.SALES);
		if (typeof layout === 'function') {
			layout = layout(to, router, store);
		}

		return layout;
	}

	// Global Navigation Guards
	router.beforeEach(async (to, from, next) => {
		store.dispatch('closeDrawers');

		let nav = getMeta(to, 'nav', null);
		if (getMeta(to, 'guest') && store.getters.isLoggedIn) {
			return next('/dashboard');
		}

		if (getMeta(to, 'superAdmin') && !store.getters.isSuperAdmin) {
			return next('/dashboard');
		}

		if (getMeta(to, 'app')) {

			if (!store.getters.isLoggedIn) {
				store.dispatch('setIntended', { path: to.fullPath });
				return next('/login');
			}
		}

		if (getMeta(to, 'commerce') && !(store.getters.currentAccount || {}).has_commerce) {
			return next('/dashboard');
		}

		if (getLayout(to) === LAYOUTS.APP) {
			store.dispatch('setSiteLoading');
		}

		const title = getMeta(to, 'title', null);
		if (title) {
			store.dispatch('setTitle', title);
		}
		store.dispatch('setNavAccountsVisible', getMeta(to, 'navAccountsVisible', true));

		next();

	});

	router.afterEach((to) => {
		store.dispatch('setLayout', getLayout(to));
		store.dispatch('setSiteLoading', false);
		window.scrollTo(0, 0);

		// if (store.state.refreshOnPageChange) {
		// 	console.log('refreshing page');
		// 	window.location.reload(true);
		// 	next(false);
		// }
	});

	router.onError(() => {
		store.dispatch('setSiteLoading', false);
	});
}
